import { createBrowserRouter } from "react-router";
import { Layout } from "./components/Layout";
import { HomePage } from "./components/HomePage";
import { ServicesPage } from "./components/ServicesPage";
import { IndustriesPage } from "./components/IndustriesPage";
import { AboutPage } from "./components/AboutPage";
import { ArticlesPage } from "./components/ArticlesPage";
import { ArticleDetailPage } from "./components/ArticleDetailPage";
import { ContactPage } from "./components/ContactPage";
import { CareersPage } from "./components/CareersPage";

export const router = createBrowserRouter([
  {
    path: "/",
    Component: Layout,
    children: [
      { index: true, Component: HomePage },
      { path: "services", Component: ServicesPage },
      { path: "industries", Component: IndustriesPage },
      { path: "about", Component: AboutPage },
      { path: "articles", Component: ArticlesPage },
      { path: "articles/:slug", Component: ArticleDetailPage },
      { path: "contact", Component: ContactPage },
      { path: "careers", Component: CareersPage },
      { path: "*", Component: HomePage },
    ],
  },
]);
